import React, { useState } from "react";
import Layout from "../components/organisms/Layout";
import { StaticImage } from "gatsby-plugin-image";
import emailBg from "../assets/images/email-bg.png";
import { FaEnvelope } from "react-icons/fa";
import { REGEX } from "../constants/index";
import { useAlert } from "react-alert";
import { Link } from "gatsby";

const Recover = () => {
	const [email, setEmail] = useState("");
	const [err, setErr] = useState(null);
	const [emailSent, setEmailSent] = useState(false);

	const EmailSent = (email) => {
		if (email && REGEX["email"].test(email)) {
			setEmailSent(true);
			setErr(null);
		} else {
			setErr("El correo no es válido");
		}
	};
	return (
		<Layout>
			<section
				className='user-account login-form email-verify'
				style={{ backgroundImage: `url(${emailBg})` }}>
				<div className='container'>
					<div className='row justify-content-center'>
						{!emailSent ? (
							<ForgotCard
								EmailSent={EmailSent}
								email={email}
								setEmail={setEmail}
								err={err}
							/>
						) : (
							<EmailSendCard email={email} />
						)}
					</div>
				</div>
			</section>
		</Layout>
	);
};

const EmailSendCard = ({ email }) => (
	<div className='col-md-12 col-lg-8'>
		<div className='card mt-md-5'>
			<div className='card-body text-center'>
				<h6 className='text-center mb-4'>
					Se envió un correo de verificación a
				</h6>
				<div className='row justify-content-center'>
					<div className='col-lg-8'>
						<div className='form-group'>
							<h5 className='text-primary pb-3'>
								<strong>{email}</strong>
							</h5>
						</div>
						<p className='px-5 mt-4'>
							<Link to='/login' className='btn btn-warning btn-block'>
								Iniciar Sesión
							</Link>
						</p>
					</div>
				</div>
			</div>
		</div>
		<StaticImage
			className='img-fluid px-5 mt-4'
			src='../assets/images/email-verify1.jpg'
			alt='email'
		/>
	</div>
);
const ForgotCard = ({ err, email, EmailSent, setEmail }) => (
	<div className='col-md-12 col-lg-8'>
		<h1 className='pb-2'>Recupera tu contraseña</h1>
		<div className='card'>
			<div className='card-body'>
				<h6 className='text-center mb-4'>
					Ingresa el correo electrónico que utilizaste para tu registro.
				</h6>
				<div className='row justify-content-center'>
					<div className='col-lg-8'>
						<div className='form-group input-group'>
							<div className='input-group-prepend'>
								<span
									className='input-group-text'
									style={{ background: "#9da6bf" }}>
									<FaEnvelope style={{ color: "#fff" }} />
								</span>
							</div>
							<input
								type='text'
								value={email}
								style={err ? { borderColor: "red" } : {}}
								onChange={(e) => setEmail(e.currentTarget.value)}
								className='form-control'
								placeholder='Correo electrónico'
							/>
						</div>
						<p className='px-5 mt-5'>
							<button
								type='button'
								onClick={() => EmailSent(email)}
								className='btn btn-warning btn-block'>
								Recuperar contraseña
							</button>
						</p>
					</div>
				</div>
			</div>
		</div>
		<StaticImage
			className='img-fluid px-5 mt-5'
			src='../assets/images/email-verify.jpg'
			alt='email'
		/>
	</div>
);
export default Recover;
